import React, { useEffect, useState } from "react";
import "./styles.css";

const Fade = ({ size, show, children }) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };

  return (
    shouldRender && (
      <div className={`col-12`}
        style={{ animation: `${show ? "fadeIn" : "fadeOut"} 0.5s`, padding: "0px" }}
        onAnimationEnd={onAnimationEnd}
      >
        {children}
      </div>
    )
  );
};

export default Fade;
